const env = {
	production:'Production',
	staging: 'Staging',
	testing: 'Testing',
	development:'Development'
}

// setup this section, port, ssl and environment
// const appPort = 4542

const ssl     = false
const config  = {
	env:process.env.REACT_APP_ENVIRONMENT,  // change here production vs development
	get environment() {
		return this.env
	},
	get protocol() {
		return ssl ? 'https':'http'
	}
}
// end section setup

const baseLocalURL =`${generateProtocol()}://localhost/collegebowling/api/v1`
const baseDevCloudURL = 'https://collegebowlingseasonapi-dev.azurewebsites.net/api/v1'
const baseTestCloudURL = 'https://collegebowlingseasonapi-test.azurewebsites.net/api/v1'
const baseStagingCloudURL = 'https://collegebowlingseasonapi.azurewebsites.net/api/v1'
const baseProdCloudURL = 'https://collegebowling-prod-api.azurewebsites.net/api/v1'

export const URL = {
	get ranking() {
		const controller = 'ranking'
		return generateURL(controller)
	}
}


function generateURL(controller) {
	switch(config.environment)
	{
		case env.development:
			return `${baseDevCloudURL}/${controller}`
		case env.staging:
			return `${baseStagingCloudURL}/${controller}`
		case env.testing:
			return `${baseTestCloudURL}/${controller}`
		case env.production:
			return `${baseProdCloudURL}/${controller}`	
		default:
			return `${baseLocalURL}/${controller}`
	}
}

function generateProtocol() {
	return (ssl ? 'https':'http')
}


// WEBPACK FOOTER //
// ./src/config.js